
import React from 'react'
import { getSizedImageUrl, getSrcSet } from '../../scripts/utils/image'

interface ImageProps {
  src: string
  width: number
  height: number
  alt?: string
  noLazy?: boolean
  className?: string
}

const Image: React.FC<ImageProps> = ({ src, width, height, alt, noLazy, className }: ImageProps) => {
  // This logic is a very simple copy of image.liquid where we take
  // a src, width, height, alt, noLazy and class to generate an image
  // with a srcset

  // Set placeholder scale
  // If the image is to be noLazy loaded we don't use this
  // but if it's lazy then it generates a smaller image for
  // the src
  const placeholderScale = 5

  return (
    <div className="image-snippet image-snippet--single">
      <img
        loading={noLazy ? 'eager' : 'lazy'}
        className={`image-snippet__img ${className ? className : ''}`}
        height={height}
        width={width}
        alt={alt ? alt : 'image'}
        srcSet={
          getSrcSet(src, null, width, height)
        }
        sizes={`${width}px`}
        src={noLazy ? getSizedImageUrl(src, `${width}x${height}`) : getSizedImageUrl(src, `${Math.round(width/placeholderScale)}x${Math.round(height/placeholderScale)}`)}
      />
    </div>

  )
}

export default Image